import { Routes } from '@angular/router';
import { ComponentsComponent } from '../components/components.component'

export const CommonLayout_ROUTES: Routes = [

    //Dashboard
    {
        path: 'dashboard',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
    },

    //Settings - Configurações
    // {
    //   path: 'setting',
    //   loadChildren: () => import('../../setting/setting.module').then(m => m.SettingModule),
    // },

    //Component
    {
        path: 'demo',
        component: ComponentsComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('../components/components.module').then(m => m.ComponentsModule)
            }
        ],
        data: {
            title: 'Components '
        }
    },

    // Charts
    {
      path: 'features',
      data: {
          title: 'features'
      },
      children: [
          {
              path: '',
              redirectTo: '/dashboard',
              pathMatch: 'full'
          },
        ]
    },

    //Hexadash UI Kit
    {
        path: 'hexadash-ui-kit',
        data: {
            title: 'Hexadash UI Kit'
        },
        children: [
            {
                path: '',
                redirectTo: '/dashboard',
                pathMatch: 'full'
            },
            {
                path: '',
                loadChildren: () => import('../../hexadash-ui-kit/hexadash-ui-kit.module').then(m => m.HexadashUiKitModule)
            },
        ]
    }
];
